import React from 'react';
import {Box, Modal} from '@mui/material';
import PreSelectedPrizeCard from "../../../components/PreSelectedPrizeCard/PreSelectedPrizeCard";
import PayoutDistributionTable from "../../../components/PayoutDistributionTable/PayoutDistributionTable";
import './PayoutInfoPopUp.style.scss';
import useDeviceType from "../../../hooks/useDeviceType";
const PayoutInfoPopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options, data}) => {
    const {isMobile} = useDeviceType();
    const {parlayName, entryFee, payoutInfos, currency, parlay} = data;

    const screenHeight = window.innerHeight;
    const modalHeight = screenHeight - 50;

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="payout-modal-title"
            aria-describedby="payout-modal-description"
            className={"PayoutInfoPopUp"}
        >
            <Box className="modal-box"
                 style={{maxHeight: isMobile? modalHeight : "auto"}}>
                <div className={"closeButton"} onClick={onClose}>X</div>
                <PayoutDistributionTable extraTitle={'CONTEST'}
                                         parlayName={parlayName}
                                         entryFee={entryFee}
                                         payoutInfos={payoutInfos}
                                         currency={currency}
                                         reLayoutHeight={!isMobile}
                />
                {parlay && <PreSelectedPrizeCard parlay={parlay}/>}
            </Box>
        </Modal>
    );
};

export default PayoutInfoPopUp;